// extracted by css-extract-rspack-plugin
var _1 = "baseUrl-Cq5N_0";
var _2 = "table-Qwopni";
export { _1 as "baseUrl", _2 as "table" }
